// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"430":"22ab1460","451":"69bf3ef9"}[chunkId] + ".chunk.css";
};